<template>
  <div class="page-wrapper">
    <h3>主体名称：{{ fzzhtMemberInfo.principalName || '-'}}</h3>
    <div class="props-wrap">
      <span class="item">主体类型：{{ detail.principalTypeStr || '-' }}</span>
      <span class="item">来源：{{ detail.sourceStr || '-' }}</span>
      <span class="item">营业执照号：{{ fzzhtMemberInfo.businessLicenseNo || '-' }}</span>
      <span class="item">注册衣加加ID：{{ fzzhtMemberInfo.userId || '无' }}</span>
      <span class="item">主体/负责人身份证：{{ fzzhtMemberInfo.responsiblePersonIdNumber || '-' }}</span>
      <span class="item">联系人姓名：{{ fzzhtMemberInfo.contactName || '-' }}</span>
      <span class="item">注册手机号：{{ fzzhtMemberInfo.registerMobileNumber || '无' }}</span>
      <span class="item">性 别：{{ fzzhtMemberInfo.gender || '-' }}</span>
      <span class="item">商品标签：{{ fzzhtMemberInfo.productLabel || '-' }}</span>
      <span class="item">职 位：{{ fzzhtMemberInfo.position || '-' }}</span>
      <span class="item">业务范围：{{ fzzhtMemberInfo.businessScope || '-' }}</span>
      <span class="item">联系人手机号：{{ fzzhtMemberInfo.contactPhoneNumber || '-' }}</span>
    </div>

    <br>
    <h3>主体介绍：</h3>
    <div style="width: 600px">
      <div v-html="fzzhtMemberInfo.desc"></div>
    </div>

    <br>
    <h3>已颁发证书：</h3>
    <template v-if="fzzhtMemberCertificateList && fzzhtMemberCertificateList.length > 0">
      <div class="certificate-type-item" v-for="item in fzzhtMemberCertificateList" :key="item.id">
        <div class="img">
          <canvas style="width: 780px; display:block;" :id="'canvas-' + item.levelId + '-' + item.id"></canvas>
        </div>
        <div class="info">
          {{ item.type }}：已生成 <br><br>
          证书编号：{{ item.number || '-' }} <br><br>
          会员级别：{{ item.level }} <br><br>
          入会时间：{{ item.joinDate }} <br><br>
          前台是否可查询：{{ item.status === 1 ? '可查询' : '不可查询' }} <br><br>
          <el-button v-if="item.fzzhtCertificateExtra && item.fzzhtCertificateExtra.certificateImage" type="primary" size="small" @click="downloadCertificate(item)">下载证书</el-button>
        </div>
      </div>
    </template>
    <div v-else>
      暂无证书
    </div>
  </div>
</template>

<script>
import { utils } from "@/common/common.js";
import { request, api } from '@/common/request_course.js';
import { Loading } from 'element-ui'
import { buildThumborUrl } from '@/common/tool.js'
import { DEFAULT_CERTIFICATE_NAME, YSWL_CERTIFICATE_NAME } from './util/constant'
export default {
  name: "certificate-detail",
  data() {
    return {
      detail: {},
      fzzhtMemberInfo: {},
      fzzhtMemberCertificateList: [],
      cerNumber: '', // 证书编号
    }
  },
  computed: {
    adminId() {
      return utils.getAdminId();
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      let loadingInstance = Loading.service({
        text: '正在加载数据...'
      });
      request({
        url: api.baseUrl + "/certificate/fzzht-member-info/detail",
        method: "get",
        params: {
          id: this.$route.query.id
        }
      }).then(res => {
        console.log(res)
        if (res.erroyCode == 200) {
          this.detail = res.data
          this.fzzhtMemberInfo = { ...res.data.fzzhtMemberInfo }
          this.fzzhtMemberCertificateList =  [ ...res.data.fzzhtMemberCertificateList ]
          const hasNumberCer = this.fzzhtMemberCertificateList.find(item => item.number)
          this.cerNumber = hasNumberCer ? hasNumberCer.number : ''
          this.$nextTick(() => {
            this.fzzhtMemberCertificateList.forEach(item => {
              let canvas = document.getElementById('canvas-'  + item.levelId + '-' + item.id);
              canvas.width = 1263; 
              canvas.height = 893;
              let context = canvas.getContext('2d');
              let image = new Image()
              if (item.fzzhtCertificateExtra && item.fzzhtCertificateExtra.certificateImage) {
                let imgUrl = buildThumborUrl(item.fzzhtCertificateExtra.certificateImage, {width: 1263, height: 893})
                image.src = imgUrl
                console.log('imgUrl', imgUrl)
                image.onload = () => {
                  context.drawImage(image, 0, 0, 1263, 893)
                  let companyTitle = item.member || ''
                  let titleLength = companyTitle.length;
                  let fontSize = 40;
                  if (titleLength > 16) fontSize = 32
                  if (titleLength > 24) fontSize = 24
                  if (titleLength > 32) fontSize = 20
                  context.font = "bold " + fontSize + "px KaiTi,STKaiti";
                  context.textAlign="center";
                  context.fillStyle="#000000";
                  context.fillText(companyTitle, 442, 180);

                  // if (item.number) {
                  //   context.font = "20px SimSun";
                  //   context.textAlign="start";
                  //   context.fillStyle="#000000";
                  //   context.fillText('No:' + item.number, 82, 64);
                  // }

                  if (this.cerNumber && (item.type === DEFAULT_CERTIFICATE_NAME || item.type === YSWL_CERTIFICATE_NAME)) {
                    context.font = "20px SimSun";
                    context.textAlign="start";
                    context.fillStyle="#000000";
                    context.fillText('No:' + this.cerNumber, 82, 64);
                  }

                  if (item.fzzhtCertificateExtra.displayName) {
                    context.font = "bold 68px SimSun";
                    context.textAlign="center";
                    context.fillStyle="#e50021";
                    context.fillText(item.fzzhtCertificateExtra.displayName, 442, 390);
                  }

                  if (item.fzzhtCertificateExtra.displayText) {
                    context.font = "bold 68px SimSun";
                    context.textAlign="center";
                    context.fillStyle="#e50021";
                    context.fillText(item.fzzhtCertificateExtra.displayText, 442, 478);
                  }

                  let level_type = ''
                  if (item.bizLevel) {
                    level_type += item.bizLevel + ':'
                  }
                  if (item.bizType) {
                    level_type += item.bizType
                  }

                  if (level_type) {
                    context.font = "bold 28px SimSun";
                    context.textAlign="start";
                    context.fillStyle="#e50021";
                    context.fillText(level_type, 925, 150);
                  }
                }
              } else {
                context.font = "36px KaiTi,STKaiti";
                context.textAlign="center";
                context.fillStyle="#000000";
                context.fillText('暂无证书模板， 无法生成预览图', 632, 446);
              }
            })
          })
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    downloadCertificate(item) {
      console.log(item)
      let self = this
      let canvas = document.createElement('canvas')
      let w = 2526, h = 1786
      canvas.width = w
      canvas.height = h
      let context = canvas.getContext('2d');
      let image = new Image()
      if (item.fzzhtCertificateExtra && item.fzzhtCertificateExtra.certificateImage) {
        let imgUrl = buildThumborUrl(item.fzzhtCertificateExtra.certificateImage, {width: w, height: h})
        image.src = imgUrl
        console.log('imgUrl', imgUrl)
        image.setAttribute("crossOrigin",'Anonymous')
        image.onload = () => {
          context.drawImage(image, 0, 0, w, h)
          let companyTitle = item.member || ''
          let titleLength = companyTitle.length; 
          let fontSize = 80;
          if (titleLength > 16) fontSize = 64
          if (titleLength > 24) fontSize = 48
          if (titleLength > 32) fontSize = 40
          context.font = "bold " + fontSize + "px KaiTi,STKaiti";
          context.textAlign="center";
          context.fillStyle="#000000";
          context.fillText(companyTitle, 884, 360);

          // if (item.number) {
          //   context.font = "40px SimSun";
          //   context.textAlign="start";
          //   context.fillStyle="#000000";
          //   context.fillText('No:' + item.number, 164, 128);
          // }
          
          if (this.cerNumber && (item.type === DEFAULT_CERTIFICATE_NAME || item.type === YSWL_CERTIFICATE_NAME)) {
            context.font = "40px SimSun";
            context.textAlign="start";
            context.fillStyle="#000000";
            context.fillText('No:' + this.cerNumber, 164, 128);
          }

          if (item.fzzhtCertificateExtra.displayName) {
            context.font = "bold 136px SimSun";
            context.textAlign="center";
            context.fillStyle="#e50021";
            context.fillText(item.fzzhtCertificateExtra.displayName, 884, 780);
          }

          if (item.fzzhtCertificateExtra.displayText) {
            context.font = "bold 136px SimSun";
            context.textAlign="center";
            context.fillStyle="#e50021";
            context.fillText(item.fzzhtCertificateExtra.displayText, 884, 956);
          }

          let level_type = ''
          if (item.bizLevel) {
            level_type += item.bizLevel + ':'
          }
          if (item.bizType) {
            level_type += item.bizType
          }

          if (level_type) {
            context.font = "bold 56px SimSun";
            context.textAlign="start";
            context.fillStyle="#e50021";
            context.fillText(level_type, 1850, 300);
          }

         canvas.toBlob(blob => {
          console.log(blob)
          let url = URL.createObjectURL(blob)
          let dName = `证书_${item.member}${item.number ? '_' + item.number: ''}.png`
          self.download(url, dName)
         }, 'image/png')
        }
      }
    },
    download(url, name) {
      const a = document.createElement('a')
      a.download = name
      a.href = url
      a.click()
    },
  },
};
</script>

<style scoped lang="scss">
.page-wrapper {
  background: #fff;
  padding: 16px;
  margin: 10px;
  .props-wrap {
    width: 1000px;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 50%;
      margin-bottom: 16px;
    }
  }
  .certificate-type-item {
    margin-bottom: 36px;
    display: flex;
    .img {
      border: 1px solid #eee;
      margin-right: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/certificate/detail.vue